<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15 5C15 3.34315 13.6569 2 12 2C10.3431 2 9 3.34315 9 5C9 6.30625 9.83485 7.41751 11.0001 7.82933L11.0001 19.9381C8.10207 19.5768 5.6854 17.6653 4.60596 15.0597L4.582 15H7L7.11853 14.9938C8.07916 14.892 8.35473 13.5593 7.44721 13.1056L3.44721 11.1056L3.34138 11.0598C2.70213 10.8247 2 11.2957 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.2566 21.2177 10.7731 20.5528 11.1056L16.5528 13.1056L16.4495 13.1641C15.6359 13.6848 15.9854 15 17 15H19.417L19.394 15.0597C18.3147 17.6651 15.8985 19.5763 13.0009 19.938L13.0009 7.82898C14.1656 7.41688 15 6.30588 15 5ZM11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5Z"
    fill="currentColor"
  />
</svg>
